module.exports = __webpack_public_path__ + "static/media/au.76e020eb.webp";